import ProxyBase from '../../../../../core/proxies/ProxyBase'

class CategoryProxy extends ProxyBase {
  postCategoryContactUs(params) {
    return this.post('ContactUs', params)
  }
}

export default new CategoryProxy('ContactUs/')
